import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import Preloader from "../../Components/Loader/Loader";
import signinLogo from "../../assets/images/login/signin-logo.png";
// import PinField from "react-pin-field";
import { OtpInput } from "reactjs-otp-input"; // ✅ correct import
import "react-toastify/dist/ReactToastify.css";
import "./ForgotPasswordOtp.css";

export function ForgotPasswordOtp() {
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  const mobile_number = localStorage.getItem("mobile_no");
  const temp_token = localStorage.getItem("otp_token");

  useEffect(() => {
    const checkMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
    setIsMobile(checkMobile);
  }, []);

  // Countdown timer for resending OTP
  useEffect(() => {
    let countdown;
    if (timer > 0) {
      countdown = setTimeout(() => setTimer((prev) => prev - 1), 1000);
    } else {
      setCanResend(true);
    }
    return () => clearTimeout(countdown);
  }, [timer]);

  // Resend OTP
  const handleResend = async () => {
    setTimer(30);
    setCanResend(false);
    try {
      const response = await axiosInstance.post("/resend-otp/", {
        mobile_number,
        user_type: "agent",
        token: temp_token,
      });

      if (response.data.status === "success") {
        toast.success(response.data.message || "OTP resent successfully!");
      } else {
        toast.error(response.data.message || "Failed to resend OTP");
      }
    } catch (error) {
      console.error("Resend error:", error);
      toast.error("Something went wrong while resending OTP");
    }
  };

  // Submit OTP
  // const handleSubmit = async () => {
  //   if (!otp || otp.length < 4) {
  //     toast.error("Please enter a valid 4-digit OTP");
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     const payload = {
  //       mobile_number,
  //       otp,
  //       user_type: "agent",
  //       token: temp_token,
  //     };

  //     const response = await axiosInstance.post("/verify-otp/", payload);

  //     if (response.data.status === "success") {
  //       // Save final token and clean up temp token
  //       if (response.data.data?.token) {
  //         localStorage.setItem("token", response.data.data.token);
  //         localStorage.removeItem("otp_token");
  //       }

  //       toast.success(response.data.message || "OTP verified successfully!");

  //       // Navigate to reset-password
  //       navigate("/reset-password");
  //     } else {
  //       toast.error(response.data.message || "Invalid OTP");
  //     }
  //   } catch (error) {
  //     console.error("OTP verification error:", error);
  //     toast.error("Something went wrong during OTP verification");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async () => {
    if (!otp || otp.length < 4) {
      toast.error("Please enter a valid 4-digit OTP");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        mobile_number,
        otp,
        user_type: "agent",
        token: temp_token,
      };

      const response = await axiosInstance.post("/verify-otp/", payload);

      if (response.data.status === "success") {
        // Save final token and clean up temp token
        if (response.data.data?.token) {
          localStorage.setItem("token", response.data.data.token);
          localStorage.removeItem("otp_token");
        }

        toast.success(response.data.message || "OTP verified successfully!");
        navigate("/reset-password");
      } else {
        // Display backend message if available
        const msg =
          response.data.message || "OTP verification failed. Please try again.";
        toast.error(msg);
      }
    } catch (error) {
      console.error("OTP verification error:", error);

      // Show error from server if available
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong during OTP verification");
      }
    } finally {
      setLoading(false);
    }
  };

  // Allow Enter key to submit OTP
  // useEffect(() => {
  //   const handleKeyDown = (e) => {
  //     if (e.key === "Enter") {
  //       e.preventDefault();
  //       handleSubmit();
  //     }
  //   };
  //   document.addEventListener("keydown", handleKeyDown);
  //   return () => document.removeEventListener("keydown", handleKeyDown);
  // }, [otp]);

  // Allow Enter key to submit OTP
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleSubmit();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [handleSubmit]);

  return (
    <>
      {loading && <Preloader />}
      <ToastContainer position="top-center" />
      <div className="signin-container">
        <div className="signin-left">
          <div>
            <div className="signin-logo">
              <img src={signinLogo} alt="Signin Logo" />
            </div>
            <div className="signin-lefttext">
              Welcome to Go Mak Referral — your platform to manage medicine
              deliveries with speed, security, and reliability. Together, we
              ensure healthcare providers get the medicines they need, on time.
            </div>
          </div>
        </div>

        <div className="signin-right">
          <div className="signin-formContainer">
            <div className="signin-title">Verify OTP</div>
            <div className="signin-subtitle">We sent a code to your mobile</div>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              {/* <div className="pinFieldContainer">
                <PinField
                  length={4}
                  onChange={(value) => setOtp(value)}
                  validate="0123456789"
                  autoFocus
                  className="pinfieldNumbers"
                  onKeyDown={(e) => {
                    // Block e, E, +, -, .
                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </div> */}

              <div className="pinFieldContainer">
                {/* <PinField
                    length={4}
                    onChange={(value) => setOtp(value)}
                    validate={(char) => /^[0-9]$/.test(char)}
                    autoFocus
                    className="pinfieldNumbers"
                    inputMode="numeric"
                    type="tel"
                    pattern="[0-9]*"
                    onKeyDown={(e) => {
                      if (
                        !/[0-9]/.test(e.key) &&
                        e.key !== "Backspace" &&
                        e.key !== "Tab" &&
                        e.key !== "ArrowLeft" &&
                        e.key !== "ArrowRight"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    onPaste={(e) => {
                      const paste = e.clipboardData.getData("text");
                      if (!/^[0-9]+$/.test(paste)) e.preventDefault();
                    }}
                  /> */}
                <OtpInput
                  value={otp}
                  onChange={(val) => {
                    const digitsOnly = String(val)
                      .replace(/\D/g, "")
                      .slice(0, 4);
                    setOtp(digitsOnly);
                  }}
                  numInputs={4}
                  inputStyle={{
                    width: "48px",
                    height: "48px",
                    margin: "0 4px",
                    fontSize: "18px",
                    borderRadius: "6px",
                    border: "1px solid #ced4da",
                    outline: "none",
                    boxSizing: "border-box",
                    textAlign: "center",
                  }}
                  containerStyle={{ justifyContent: "center", display: "flex" }}
                  shouldAutoFocus={true}
                  isInputNum={true}
                />
              </div>

              <div style={{ marginTop: "10px" }}>
                <span>Didn’t receive the code? </span>
                <button
                  type="button"
                  onClick={handleResend}
                  disabled={!canResend}
                  className="resend-btn"
                >
                  {canResend ? "Resend OTP" : `Resend in ${timer}s`}
                </button>
              </div>

              <div className="btnLogin" style={{ marginTop: "20px" }}>
                <button type="submit" disabled={loading}>
                  {loading ? "Verifying..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
